import { HttpBackend } from '@angular/common/http';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { environment } from '../../../environments/environment';

// AoT requires an exported function for factories
export function HttpLoaderFactory(_httpBackend: HttpBackend) {
  return new MultiTranslateHttpLoader(_httpBackend, [
     { prefix: './i18n/common/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/errors/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/forms/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/sign-in/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/sign-up/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/kimbo-profile/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-common/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-layout/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-nav/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-country/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-fields/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-users/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-edit-user/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-settings/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-exchange-rates/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-create-healthcare-module/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-edit-healthcare-module/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-healthcare-modules/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-create-healthcare-provider/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-edit-healthcare-provider/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-healthcare-providers/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-edit-financial-transaction/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-edit-financial-transaction/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-financial-transactions/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-discount-cards/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-edit-discount-card/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-create-discount-card/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-role/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/kimbo-wallet/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/subscriptions/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-metrics/', suffix: `.json?v=${environment.appVersion}`  },
    {
      prefix: './i18n/admin-contact-management/',
      suffix: `.json?v=${environment.appVersion}` ,
    },
    { prefix: './i18n/hcp-registration/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-benefit/', suffix: `.json?v=${environment.appVersion}`  },
    { prefix: './i18n/admin-care/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/admin-settings-modal/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/benefit-layout/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-layout/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-home/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-profile/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-wallet/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-top-up/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-send-credits/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/kimbo-create-contact/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/plans/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/tenant-layout/', suffix: `.json?v=${environment.appVersion}` },
    { prefix: './i18n/admin-tenant/', suffix: `.json?v=${environment.appVersion}` },
  ]);
}
